var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"!text-lg",attrs:{"type":"text","loading":_vm.loading,"size":"default"},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.loading)?_vm._t("default",function(){return [_c('i',{class:[_vm.icon, _vm.cls]})]}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }